import { createContext, useContext } from "react";

export const DEFAULT_CONTENT = {
    whatsapp: { number: "5582991163764", display: "(82) 99116-3764" },
    hero: {
        badge: "Minimercado autônomo · 24h",
        title1: "Seu mercado,",
        title2: "dentro de casa.",
        subtitle:
            "O Conbox é um minimercado autônomo instalado dentro do condomínio: prateleiras abastecidas, geladeiras cheias e pagamento automático — 24 horas, todos os dias. Esta página foi feita para apresentar o projeto ao síndico e à comissão do condomínio.",
        cta1: "Solicitar implantação no meu condomínio",
        cta2: "Falar no WhatsApp",
    },
    beneficios: {
        title1: "Um mercado completo que trabalha ",
        title2: "enquanto o condomínio dorme",
        subtitle:
            "A Conbox nasceu para colocar a conveniência do dia a dia a poucos passos do apartamento — com operação autônoma, segura e sem complicação para o síndico.",
        b1: {
            t: "Funciona 24 horas",
            d: "Todos os dias da semana, sem fechar. Morador que sai cedo, chega tarde ou esqueceu o jantar resolve na hora — sem depender de horário de mercado.",
        },
        b2: {
            t: "Seguro",
            d: "Monitoramento por câmeras e controle de acesso — só entram moradores autorizados, por QR Code ou cartão do condomínio.",
        },
        b3: {
            t: "Prático",
            d: "Pagamento no autoatendimento: Pix, cartão de crédito, débito ou aproximação. Sem dinheiro, sem fila de caixa.",
        },
        b4: {
            t: "No seu condomínio ou empresa",
            d: "Loja compacta em formato contêiner ou montada em espaço cedido dentro do condomínio ou da empresa: garagem, área de convivência ou saguão.",
        },
        note1: "até de madrugada!",
        note2: "zero deslocamento!",
    },
    passos: {
        title: "Como funciona?",
        subtitle: "quatro passos e nada de fila",
        steps: [
            { t: "Você acessa", d: "Abra a porta pelo app, QR Code ou cartão do condomínio. Simples assim." },
            { t: "Escolhe os produtos", d: "Gôndonas e geladeiras abastecidas: do lanche rápido ao jantar de hoje." },
            { t: "Paga como preferir", d: "No totem de autoatendimento: Pix, cartão ou aproximação." },
            { t: "É só levar!", d: "Sem fila e sem espera. Simples, rápido e seguro." },
        ],
    },
    sobre: {
        title: "Missão, visão e valores",
        subtitle:
            "O Conbox nasceu de uma ideia simples: o mercado de bairro, do lado de dentro do condomínio — com a segurança e a praticidade da tecnologia.",
        missao:
            "Levar conveniência, economia de tempo e qualidade de vida aos moradores, com um mercado completo funcionando 24 horas dentro do condomínio.",
        visao: "Ser a rede de minimercados autônomos de condomínios mais amada do Brasil, presente nos bairros onde as pessoas vivem.",
        valores:
            "Segurança em primeiro lugar, praticidade no dia a dia, proximidade com moradores e síndicos, e total transparência com o condomínio.",
    },
    sindicos: {
        title1: "Um mercado de presente para o condomínio. ",
        title2: "de verdade.",
        subtitle:
            "A Conbox ocupa um pequeno espaço na área comum e devolve conveniência, segurança e valorização. O dossiê abaixo resume o que o condomínio ganha:",
        pitches: [
            { t: "R$ 0 de custo", d: "A Conbox instala, opera e mantém todo o mercado — estrutura, estoque e limpeza. Sem investimento do condomínio." },
            { t: "Segurança de ponta a ponta", d: "Acesso controlado por QR Code ou cartão do condomínio e monitoramento por câmeras 24 horas." },
            { t: "Reposição e limpeza inclusas", d: "Equipe própria da Conbox abastece o estoque e cuida da conservação. O síndico não gerencia nada." },
            { t: "Comodidade e valorização", d: "Um mercado 24h na entrada é o diferencial que os moradores amam e valoriza o condomínio." },
        ],
        sim_title: "Simulador do condomínio",
        sim_note: "Apresentação completa para síndico e comissão, sem compromisso.",
    },
    corporativo: {
        tag: "Para empresas corporativas",
        title1: "Conbox no escritório, ",
        title2: "conforto para o time.",
        subtitle:
            "Minimercado autônomo 24h dentro da empresa: lanches, bebidas e essenciais a poucos passos da mesa — em contêiner ou em espaço cedido, sem custo e sem operação para o RH.",
        pitches: [
            { t: "R$ 0 de custo", d: "A Conbox instala, opera e mantém todo o mercado. A empresa não investe nada e não gerencia nada." },
            { t: "Turnos sem limites", d: "Funciona 24 horas, ideal para plantões, madrugadas e fins de semana de trabalho." },
            { t: "Acesso controlado", d: "Entrada por QR Code ou cartão corporativo, com monitoramento por câmeras 24h." },
            { t: "Benefício que fideliza", d: "Conveniência dentro do escritório melhora a rotina, a satisfação e a retenção do time." },
        ],
        cta: "Receber proposta para a minha empresa",
        cta_note: "Proposta para RH, facilities e gestores — sem compromisso.",
    },
    categorias: {
        title: "Tem tudo o que o morador precisa",
        subtitle:
            "O mix é montado para o dia a dia do condomínio e ajustado ao perfil dos moradores. Toque em uma categoria:",
        items: {
            alimentos: "Lanches e snacks; Pão e padaria; Congelados prontos; Biscoitos e doces; Temperos do dia a dia",
            bebidas: "Refrigerantes gelados; Sucos e águas; Cervejas; Cafés e energéticos",
            higiene: "Sabonetes e shampoos; Creme dental; Papel higiênico; Cuidados diários",
            limpeza: "Detergentes; Sabão em pó; Papel toalha e cozinha; Sacolas e lixo",
            conveniencia: "Gelo e carvão; Pilhas e lâmpadas; Petiscos pet; Sorvetes",
        },
    },
    galeria: {
        title: "A loja, por dentro e por fora",
        subtitle: "Estrutura compacta, acabamento premium e tudo funcionando de forma autônoma.",
    },
    novidades: {
        title: "Inaugurações, promoções e eventos",
        subtitle: "Acompanhe as últimas notícias das lojas Conbox nos condomínios.",
    },
    faq: {
        title: "Perguntas frequentes",
        items: [
            { q: "Quanto custa para o condomínio?", a: "R$ 0. A Conbox instala, opera e mantém todo o mercado — estrutura, equipamentos, estoque e limpeza — sem nenhum investimento ou taxa para o condomínio." },
            { q: "E o consumo de energia?", a: "O consumo do equipamento é medido e reembolsado pela Conbox. O condomínio não tem despesa elétrica adicional por causa da loja." },
            { q: "Como funciona a segurança?", a: "O acesso é controlado por QR Code, app ou cartão do condomínio — só entram moradores autorizados. O ambiente conta com monitoramento por câmeras 24 horas." },
            { q: "Quanto espaço é necessário?", a: "Trabalhamos com dois formatos que se adaptam ao local: loja contêiner ou loja montada em espaço cedido dentro do condomínio ou da empresa — garagem, área de convivência, saguão ou hall, a partir de aproximadamente 5 m²." },
            { q: "Quem repõe os produtos e faz a limpeza?", a: "A equipe própria da Conbox faz a reposição frequente do estoque e a limpeza completa da loja. O síndico não tem nenhuma operação para gerenciar." },
        ],
    },
    form: {
        title1: "Quer o Conbox no seu condomínio?",
        title2: "a gente liga para você.",
        subtitle:
            "Preencha os dados ao lado: a mensagem chega pronta no nosso WhatsApp e nossa equipe agenda a apresentação para o síndico e a comissão — sem compromisso.",
        b1: "Apresentação completa para síndico e conselho",
        b2: "Projeto sob medida para o espaço do condomínio",
        b3: "Proposta sem nenhum custo e sem compromisso",
    },
    footer: {
        cta_title: "Pronto para colocar um mercado dentro do seu condomínio?",
        cta_slogan: "seu mercado, dentro de casa.",
        atendimento: "Atendimento para condomínios e empresas em todo o Brasil.",
        instagram: "@conbox24",
    },
};

export const mergeContent = (saved = {}) => {
    const out = {};
    for (const key of Object.keys(DEFAULT_CONTENT)) {
        const v = saved ? saved[key] : undefined;
        if (Array.isArray(DEFAULT_CONTENT[key])) {
            out[key] = Array.isArray(v) ? v : DEFAULT_CONTENT[key];
        } else if (typeof DEFAULT_CONTENT[key] === "object") {
            out[key] = v && typeof v === "object" ? { ...DEFAULT_CONTENT[key], ...v } : { ...DEFAULT_CONTENT[key] };
        } else {
            out[key] = v !== undefined && v !== null ? v : DEFAULT_CONTENT[key];
        }
    }
    return out;
};

export const ContentContext = createContext(DEFAULT_CONTENT);
export const useContent = () => useContext(ContentContext);
